import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";

export const GetPostList = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-post-list?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetPostListByCategories = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-post-list-by-categories?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetPostListbyCreatorID = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-post-list-by-creatorid?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetFeaturedPostList = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-featured-post-list?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetBlogCategories = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-blog-categories?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetBlogbyPostID = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-blog-post-by-postid?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetBlogbySlug = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-blog-post-by-slug?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetBlogPostPreview = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-blog-post-preview?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetBlogPostComments = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-blog-post-comments?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetCommentsList = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-blog-post-comments?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};

export const AddComment = async (data) => {
  return decryptData(
    await axios.post(`/add-blog-post-comment`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const AddCommentReply = async (data) => {
  return decryptData(
    await axios.post(`/add-blog-post-comment-reply`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const UpdateCommentLike = async (data) => {
  return decryptData(
    await axios.post(`/update-comment-like`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const UpdateCommentUnLike = async (data) => {
  return decryptData(
    await axios.post(`/update-comment-unlike`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const UpdatePostLike = async (data) => {
  return decryptData(
    await axios.post(`/update-post-like`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const UpdatePostUnLike = async (data) => {
  return decryptData(
    await axios.post(`/update-post-unlike`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const UpdateViewCount = async (data) => {
  return decryptData(
    await axios.post(`/update-view-count-of-post`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};
export const UpdateCommentReplyLike = async (data) => {
  return decryptData(
    await axios.post(`/update-comment-reply-like`, {
      reqData: encryptData({ ...data, platformType: getBrowserName() }),
    })
  );
};

